<template>
  <q-page class="flex flex-center">
    <!-- <div class="column justify-center items-center q-ma-md"> -->
      <q-img
          src="../../public/BigCLogo2022.png"
          style="width: 100px; height: 100px"
          />
          <h2>E-Learning System</h2> 
      <!-- <div class="col" style="width: 1260px;">
        <div class="text-h2 fit">
          <q-img
          src="../../public/BigCLogo2022.png"
          style="width: 100px; height: 100px"
          />
          E-Learning System
        </div>
      </div> -->

      <!-- <div class="row col-10 justify-start" style="width: 1260px;">
        <div class="col">
          <q-card flat bordered style="width:600px">
            <q-card-section class="bg-green text-center text-white" tag="div">
              คู่มือแนะนำการใช้ระบบ
            </q-card-section>
            <q-separator/>
            <q-card-section tag="div">
            </q-card-section>
          </q-card>
        </div>
        <div class="col">
          <q-card flat bordered style="width:600px">
            <q-card-section class="bg-green text-center text-white" tag="div">
              แผนการเรียนปี 2566
            </q-card-section>
            <q-separator/>
            <q-card-section tag="div">
            </q-card-section>
          </q-card>
        </div>
      </div> -->
    <!-- </div> -->
  </q-page>
</template>

<style></style>

<script lang="ts">
export default {
  name: "HelloWorld",
};
</script>
